import React, { lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { retry } from "./utils/CommonFunctions";
import AboutUs from "./pages/AboutUs";
import FindTalent from "./pages/FindTalent";
import FourOhFour from "./pages/FourOhFour";
import JoinUs from "./pages/JoinUs";
import ReachOut from "./pages/ReachOut";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
const Home = lazy(() => retry(() => import("./pages/Home")));

const Routes = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/about-us",
      element: <AboutUs />,
    },
    {
      path: "/find-talent",
      element: <FindTalent />,
    },
    {
      path: "/join-us",
      element: <JoinUs />,
    },
    {
      path: "/reach-out",
      element: <ReachOut />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/terms-and-conditions",
      element: <TermsAndConditions />,
    },
    {
      path: "404",
      element: <FourOhFour />,
    },
    {
      path: "/*",
      element: <Navigate replace to="/404" />,
    },
  ]);
  return routes;
};

export default Routes;
